// --- React & Redux
import React from "react";
import { useSelector } from "react-redux";
// --- External UI Libraries
import { Drawer } from "antd";
// --- Components
// -- Hooks & Actions
// --- Utils
import { useRateCardsActions } from "tap/store/rateCards/useRateCards.js";
import Button from "@dtci/spellbook/Button";
import { JobTasksForm } from "./tasks-form";

export const UploadTasksDrawer = ({ onOpenUploadDialog }) => {
  const { isUploadTasksDrawerOpen } = useSelector((state) => state.rateCards);
  const { updateRateCards } = useRateCardsActions();

  const handleClose = async () => {
    updateRateCards({
      isUploadTasksDrawerOpen: false,
      rateCardJobTasks: [],
    });
  };

  return (
    <Drawer
      className="create-drawer"
      title="Upload Tasks"
      width={750}
      placement="right"
      open={isUploadTasksDrawerOpen}
      onClose={handleClose}
      bodyStyle={{ paddingBottom: 80 }}
      footer={
        <div
          className="button-row"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Button
            iconType="fa-solid fa-xmark"
            labelText="close"
            styleType="link"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            iconType="fa-solid fa-upload"
            labelText="Upload"
            styleType="link"
            onClick={() => {
              onOpenUploadDialog();
              handleClose();
            }}
          >
            Upload
          </Button>
        </div>
      }
    >
      <JobTasksForm />
    </Drawer>
  );
};
